import '~in-app/styles/index.css'

import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
// import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { RegisterOfflineIcon, ThemeProvider } from '~in-app/components'
import { router } from '~in-app/router'

import { queryClient } from './lib/tanstack-query/query-client'

// Conditionally initialize Sentry if not in development mode

const rawUrl = import.meta.env.VITE_API_URL
const url = rawUrl.trim().replace(/\/$/, '') // remove trailing slash

const isStaging = url === 'http://192.168.20.6:9201' || url === 'http://192.168.20.7:9201'
Sentry.init({
  dsn: 'https://41a37c7e66850ab4c139a5ed397d96ca@sentry.proscalar.cloud/4',
  tracesSampleRate: 1.0,
  environment: isStaging ? 'staging' : 'production',
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

// Render the app
const rootElement = document.getElementById('root')
if (rootElement != null && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <QueryClientProvider client={queryClient}>
      <RegisterOfflineIcon />

      <ThemeProvider
        attribute="class"
        defaultTheme="system"
      >
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>,
  )
}
